'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const BaseView = require('components-framework/view/base.view');
const ShoppingCart = require('od-modules/cart/cart');

module.exports = createWidgetFactory({
    el: $('.cart_debugger'),
    name: 'cart_debugger',
    viewClass: BaseView.extend({
        initialize() {
            ShoppingCart.subscribe(this.onChange.bind(this));
            this.render();
        },

        onChange() {
            this.render();
        },

        render() {
            this.$el.html(this.templates.default({
                items: ShoppingCart.getUncommittedItems(),
                actions: ShoppingCart.getActions(),
            }));
        },
    }),
    methods: {

    },
});
